var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3848 7.06844C11.9943 7.45896 11.3612 7.45896 10.9706 7.06844L7.67773 3.77554L7.67773 11.3613C7.67773 11.9136 7.23002 12.3613 6.67773 12.3613C6.12545 12.3613 5.67773 11.9136 5.67773 11.3613L5.67773 3.77554L2.38484 7.06843C1.99432 7.45896 1.36115 7.45896 0.970627 7.06843C0.580104 6.67791 0.580104 6.04475 0.970628 5.65422L5.87376 0.654222C6.07488 0.453101 6.36605 0.355558 6.65451 0.361592C6.66223 0.361416 6.66997 0.361328 6.67773 0.361328C6.95427 0.361328 7.20459 0.473578 7.38562 0.655L12.3848 5.65422C12.7754 6.04475 12.7754 6.67791 12.3848 7.06844Z",
    fill: "#EF6868"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/Up-Arrow.2efd9e8984115b203d5245b327ca0c52.svg";
export { ForwardRef as ReactComponent };